/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {WixxServerDataParser} from "../WixxServerDataParser";
import {IWixxGameData} from "./IWixxServerData";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";

export class WixxParsedGameData extends SpinParsedGameData {

    private readonly _stackedReelFourRespinTriggered:boolean;
    private readonly _stackedReelFourRespinActive:boolean;
    private readonly _symbolToWildRespinActive:boolean;
    private readonly _multiplierRespinActive:boolean;
    private readonly _wildHighlight:boolean[][];
    private readonly _excitementPositions:boolean[][];
    public readonly betWaysData:IBetWayWinData[];

    public get stackedReelFourRespinTriggered():boolean {
        return this._stackedReelFourRespinTriggered;
    }

    public get stackedReelFourRespinActive():boolean {
        return this._stackedReelFourRespinActive;
    }

    public get symbolToWildRespinActive():boolean {
        return this._symbolToWildRespinActive;
    }

    public get multiplierRespinActive():boolean {
        return this._multiplierRespinActive;
    }

    public get wildHighlight():boolean[][] {
        return this._wildHighlight;
    }

    public get excitementPositions():boolean[][] {
        return this._excitementPositions;
    }

    constructor(rawData:IWixxGameData, dataParser:WixxServerDataParser) {
        super(rawData, dataParser);

        this._stackedReelFourRespinTriggered = dataParser.parseStackedReelFourRespinTriggered(rawData);
        this._stackedReelFourRespinActive = dataParser.parseStackedReelFourRespinActive(rawData);
        this._symbolToWildRespinActive = dataParser.parseSymbolToWildRespinActive(rawData);
        this._multiplierRespinActive = dataParser.parseMultiplierRespinActive(rawData);
        this._wildHighlight = dataParser.parseHighlightWilds(rawData);
        this._excitementPositions = dataParser.parseExcitementPositions(rawData);
        this.betWaysData=<IBetWayWinData[]>rawData.betWayWins;
    }
}